import Image from "./image";

export { Image };
export default Image;
